import { render, staticRenderFns } from "./hold.vue?vue&type=template&id=1e223a64&scoped=true"
import script from "./hold.vue?vue&type=script&lang=js"
export * from "./hold.vue?vue&type=script&lang=js"
import style0 from "./hold.vue?vue&type=style&index=0&id=1e223a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e223a64",
  null
  
)

export default component.exports